// @ts-ignore

import { CheckemailPageTemplate } from '@/templates/ondemand/signup/checkemail/checkemail-page/src/checkemail-page.template';

export const CheckemailPage = () => <CheckemailPageTemplate />;
